import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useSelectBrandId from "#features/Giftcard/hooks/useSelectBrand";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "주차권 사전 구매",
    content: "주차비를 선결제하시면 정산소에서의 대기 시간을 줄일 수 있습니다. \n(선결제 시 약 2초, 현장 결제 시 약 7~10초)\n\n[ICON:check]주차권 사전 구매 이용 방법 \n①랜더스 APP/하단 사전 정산 링크를 통해 사전 정산 시스템 접속 \n ②회원가입 및 로그인을 해주세요. \n ③입차 희망일을 지정해주세요. \n ④주차요금을 결제해주세요. \n ⑤입차 시 차단기가 자동으로 올라갑니다. \n\n※ 주차권 사전 구매 후 미사용 및 입차 후에는 환불/취소 불가합니다." ,
    reference: "",
    buttons: [
      { 
        title: "주차권 사전 구매 바로가기",
        link: "http://munhak.hiparking.co.kr/"
      }
    ]
  },
  {
    title: "입/출차 안내",
    content:
      "[ICON:check]입차 안내 \n- 차량 이용 시 경기 개시 1시간 30분 전 입차를 권장 드립니다.\n- 주말 홈경기 시 대중교통 이용을 권장 드립니다. \n[SPACE]*주말에는 약 4,000대의 차량이 입차함에 따라 입차 시 많은 시간이 소요될 수 있습니다. \n\n[ICON:check]네비게이션 검색 \n- 인천 SSG랜더스필드 동문 > 지하1층,동문광장 \n- 인천 SSG랜더스필드 북문 > 북문광장,주경기장 주변 \n- 인천 SSG랜더스필드 지하주차장 > 지하2층/3층 \n\n※ 문학경기장 만차 시 입차가 제한될 수 있으니 주변 공영 주차장을 이용하시기 바랍니다.(인천문화예술회관 주차장 등) \n\n[ICON:check]출차 안내 \n- 주말에는 약 4,000대의 차량이 입차함에 따라, 경기 종료   후 출차 시 평균 40분에서 1시간 가량 소요됩니다. \n- 빠른 출차를 위해 주차요원의 안내에 따라 안전하게 출차해 주시기 바랍니다.",
    reference: ""
  },
  {
    title: "주차장 운영시간",
    content:
      "SSG랜더스필드 주차장은 24시간 운영됩니다. \n\n ※ 입차 시간 24시간 기준으로 요금 부과 \n※ 출차 시 추가요금이 발생된 경우 출차 무인정산기를 통해 추가 요금 지불 후 출차 가능합니다. \n※ 주차장 이동 통로는 24시간 개방되어 있습니다. \n\n주차장 이용 관련 자세한 상담은 주차 업체를 통해 문의 가능합니다. \n\n[ICON:check]주차장 문의 \n- 업체 : ㈜하이파킹 070-7119-3198 \n- 운영시간 \nㆍ홈경기 시 14시~경기 종료 시까지 \nㆍ경기 없는날 09시 30분~15시", 
    reference: "",
    buttons: [
      { 
        title: "주차업체 문의 전화",
        link: "tel:070-7119-3198"
      }
    ]
  },
];


const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950">{formatText(item.content)}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const ParkingPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="주차" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div>SSG랜더스필드는 지상주차장 및 지하주차장(지하 1층~4층)으로 운영 됩니다.</div>
        <br />
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/>주소: 인천 미추홀구 매소홀로 618(인천 SSG랜더스필드)</div>
        <br/>
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/>주차요금(일 기준)</div>
        <div>- 승용차 : 2,000원</div>
        <div>- 15인승 이상 승합 : 4,000원 </div>
        <div>- 25인승 이상 버스 : 6,000원</div>
        <div>- 월 정기권 : 40,000원</div>
        <br/>
        <div>※ 홈경기 시 선불제로 운영됩니다.</div>
        <div className="pl-4">(행사 시작 3시간 전~)</div>
        <div>※ 입차 후 15분 이내 무료 회차</div>
        <div>※ 장애인, 유공자, 저공해 차량 50%/경차 60% 할인</div>
        <div>(정산소 호출 및 관제실 확인 후 할인 적용)</div>
        <div>※ 주차요금은 주차장 이용 시 발생하는 요금으로 행사 및 대관(프로야구, 콘서트, 체육경기 등) 취소 사유로 환불되지 않습니다.</div>
        <br/>
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/>주차장 문의</div>
        <div>- 업체 : ㈜하이파킹 070-7119-3198</div>
        <div>- 운영시간</div>
        <div>ㆍ홈경기 시 14시~경기 종료 시까지</div>
        <div>ㆍ경기 없는날 09시 30분~15시</div>
        <br />
        <LinkItem
          title="주차업체(하이파킹) 문의 전화"
          url="tel:070-7119-3198"
          onClick={() => trackButtonClick("주차_주차업체(하이파킹) 문의 전화")}
        />
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("주차_전화상담")}
        />
      </div>
    </section>
  );
};

export default ParkingPage;
